import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_content-transfer-hub-1/artifacts/tsr0a3r8_FOY%20Logo%204-trans.png";

/**
 * Logo
 *  variant="default" — transparent PNG, works on any background
 *  variant="dark"    — same transparent PNG (sits cleanly on dark footer)
 */
export default function Logo({ size = 170, className = "", alt = "The Fountain of Youth Extra Virgin Olive Oil" }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img
        src={LOGO_URL}
        alt={alt}
        style={{ width: size, height: "auto", display: "block" }}
        className="select-none"
        draggable={false}
        loading="eager"
      />
    </div>
  );
}
